import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
const GOLD = '#d8b878';
const FAQS = [{
  q: '¿Este ebook es religioso?',
  a: 'No. Toca temas espirituales, simbólicos y de conciencia, pero no pertenece a una religión específica.'
}, {
  q: '¿Es una guía práctica paso a paso?',
  a: 'Es principalmente una lectura de reflexión profunda, desprogramación y expansión de conciencia. Su propósito es ayudarte a mirar tu vida desde otra perspectiva, cuestionar patrones y hacerte preguntas más conscientes.'
}, {
  q: '¿Puedo leerlo desde mi celular?',
  a: 'Sí. Recibirás un PDF digital que puedes leer desde tu celular, tablet o computadora.'
}, {
  q: '¿Cuándo recibo el ebook?',
  a: 'El acceso es inmediato después de completar la compra. Recibirás el ebook en formato PDF.'
}, {
  q: '¿Este ebook reemplaza terapia o ayuda profesional?',
  a: 'No. Este ebook es una herramienta de reflexión, autoconocimiento y crecimiento personal. No sustituye terapia, diagnóstico ni acompañamiento profesional.'
}, {
  q: '¿Qué pasa si no recibo el correo?',
  a: 'Revisa tu bandeja principal, Spam, Promociones u Otros. Si no encuentras el correo de acceso, puedes comunicarte con soporte para recibir ayuda.'
}, {
  q: '¿Hay reembolso?',
  a: 'Al tratarse de un producto digital con acceso inmediato, la compra no es reembolsable.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(null);
  return <div className="mt-16 md:mt-24 max-w-2xl mx-auto text-left" data-id="element-61">
      {/* Header */}
      <div className="text-center mb-8 md:mb-10" data-id="element-62">
        <span className="inline-block font-inter text-[10px] md:text-xs tracking-[0.4em] uppercase mb-4" style={{
        color: 'rgba(216,184,120,0.7)'
      }} data-id="element-63">
          Antes de entrar al portal
        </span>
        <h3 className="font-cinzel text-2xl md:text-3xl text-matrix-cream drop-shadow-[0_0_12px_rgba(245,230,200,0.12)]" data-id="element-64">
          Preguntas frecuentes
        </h3>
      </div>

      {/* Accordion */}
      <div className="divide-y divide-matrix-green/12 border-y border-matrix-green/15" data-id="element-65">
        {FAQS.map((faq, i) => {
        const isOpen = open === i;
        return <div key={i} data-id="element-66">
              <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-4 md:py-5 text-left transition-colors hover:text-matrix-cream group" data-id="element-67">
                <span className={`font-cinzel text-base md:text-lg leading-snug transition-colors ${isOpen ? 'text-matrix-cream' : 'text-matrix-white/85'}`} data-id="element-68">
                  {faq.q}
                </span>
                <span className="shrink-0 flex h-7 w-7 items-center justify-center rounded-full border transition-colors" style={{
              borderColor: isOpen ? 'rgba(216,184,120,0.5)' : 'rgba(0,255,65,0.25)',
              color: GOLD
            }} data-id="element-69">
                  {isOpen ? <MinusIcon size={15} data-id="element-70" /> : <PlusIcon size={15} data-id="element-71" />}
                </span>
              </button>

              <AnimatePresence initial={false} data-id="element-72">
                {isOpen && <motion.div key="content" initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-73">
                    <p className="pb-5 pr-9 text-sm md:text-base text-matrix-white/70 font-light leading-relaxed" data-id="element-74">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </div>;
}